import { render } from "./ValueRoadMap.vue?vue&type=template&id=528d415c"
import script from "./ValueRoadMap.vue?vue&type=script&lang=js"
export * from "./ValueRoadMap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__